
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-drip-marketing",
      function () {
        return require("private-next-pages/whatsapp-drip-marketing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-drip-marketing"])
      });
    }
  